function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * 会議素材（メッセージ）　モデル
 */
var UploadMessageMaterialsInstanceModel =
/**
 * コンストラクタ
 *
 */
function UploadMessageMaterialsInstanceModel() {
  _classCallCheck(this, UploadMessageMaterialsInstanceModel);

  this.SessionId = -1;
  this.MessageId = -1;
  this.Title = "";
  this.Contents = "";
  this.Explanation = "";
  this.Interactable = 0;
  this.IsQuiz = 0;
  this.CanMultipleSelect = 0;
  this.CanIncorrectNext = 0;
  this.MessageItems = [];
};

export { UploadMessageMaterialsInstanceModel as default };